/**
 * @Author: lifuzhao
 * @Date: 2019-07-12
 * @Project: driver
 */
import Vue from 'vue'
import axios from './axios'
import bus from './bus'
import fn from './fn'

const plugins = [
  axios
  , bus
  , fn
]
plugins.forEach(plugin => {
  Vue.use(plugin)
})